import { BASE_URL } from "../constants.jsx";

export function forgotPass(email) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${BASE_URL}/user/forgot-password`, {
        method: "POST",
        body: JSON.stringify(email),
        headers: { "content-type": "application/json" },
      });
      if (response.ok) {
        const data = await response.json();
        const authToken = response.headers.get("Authorization");

        resolve({ data, authToken });
      } else {
        const error = await response.text();
        reject(error);
      }
    } catch (error) {
      reject(error);
    }
  });
}
export function resetPass(getData) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${BASE_URL}/user/reset-password`, {
        method: "POST",
        body: JSON.stringify(getData.updateInfo),
        headers: {
          "content-type": "application/json",
          Authorization: `${getData.authToken}`,
        },
      });
      if (response.ok) {
        const data = await response.json();

        resolve({ data });
      } else {
        const error = await response.text();
        reject(error);
      }
    } catch (error) {
      reject(error);
    }
  });
}
